import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import Loader from "../../Components/Common/Loader";
import {
    AESEncryption,
    ApiResDecrypt,
    noDataFound,
} from "../../CommonMethhods/CommonMethods";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import AdvanceTaxReportTable from "../../Components/ReportTables/AdvanceTaxReportTable";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function AdvanceTaxReport() {
    const storeToken = localStorage.getItem("ssoToken");
    const userType = localStorage.getItem("partnerType").toLowerCase();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [count, setCount] = useState();
    const [show, setShow] = useState(false);
    const [finalData, setFinalData] = useState({});
    const [errorGrid, setErrorGrid] = useState(false);
    const [errorResp, setErrorResp] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [submitNameError, setSubmitNameError] = useState(false);
    const [page, setPage] = useState(1);
    const [clientList, setClientList] = useState([]);
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [loader, setLoader] = useState(false);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [customShow, setCustomShow] = useState(false);
    const [selectDuration, setSelectDuration] = useState("");
    const [downloadLoader, setDownloadLoader] = useState(null)
    const [isSelected, setIsSelected] = useState(true);
    const [smallLoaderMail, setSmallLoaderMail] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [surchargeData, setSurchargeData] = useState([]);
    const [healthEduData, setHealthEduData] = useState([]);
    const [taxYear, setTaxYear] = useState("");
    const [taxYearShow, setTaxYearShow] = useState(false);
    const taxYearDropdownRef = useRef(null);
    const [taxCategory, setTaxCategory] = useState("individual");
    const [taxYearError, setTaxYearError] = useState("");
    const clientInputRef = useRef(null);
    const dropdownRef = useRef(null);
    const taxYearOptions = ["2025-26", "2026-27"];
    const [taxReportPayload, setTaxReportPayload] = useState(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }

            if (taxYearDropdownRef.current && !taxYearDropdownRef.current.contains(event.target)) {
                setTaxYearShow(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const debouncedValue = useDebounce(clientCode, 1000);
    useEffect(() => {
        handleClientName(debouncedValue);
    }, [debouncedValue]);

    if (fromDate == "" || toDate == "") {
        const current = new Date();
        const CurrentYear = current.getFullYear();
        const CurrentMonth = current.getMonth();
        if (CurrentMonth < 4) {
            const newYear = `04-01-${CurrentYear - 1}`;
            const date = `${current.getMonth() + 1
                }-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
            setFromDate(newYear);
            setToDate(date1);
        } else {
            const newYear = `04-01-${CurrentYear}`;
            const date = `${current.getMonth() + 1
                }-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
            setFromDate(newYear);
            setToDate(date1);
        }
    }

    async function searchApiDetail(code, NoPage) {
        setScrollLoader(true);
        let payloadValue = {
            keyword: code,
            Status: "",
            PageNo: NoPage,
            PageSize: 10,
        };
        console.log(payloadValue, "payload");


        const encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axiosInstance.post(
                Client_Search.Search_URL,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getSearchDetail?.data);

            if (res?.status === 0) {
                setCount(res?.data?.TotalCount);
                setNameError(false);
                if (page > 1) {
                    setClientList((prev) => {
                        return [...prev, ...res?.data?.clients];
                    });
                } else {
                    setClientList(res?.data?.clients);
                }
            } else {
                setNameError(res?.message);
                setClientList([])
            }
        } catch (error) {
        } finally {
            setScrollLoader(false);
        }
    }
    function handleClientName(data) {
        if (data) {
            searchApiDetail(data, 1);
            setNameError(false);
            setClientList([]);
            setPage(1);
        }
    }

    useEffect(() => {
        if (page > 1) {
            searchApiDetail(clientCode, page);
        }
    }, [page]);

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(count <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    const getAdTaxTableData = async () => {
        setLoader(true);
        let payloadValue = {
            clientCode: clientCode,
            taxYear: taxYear,
            category: taxCategory

        };
        console.log(payloadValue, "payloadValuetax");

        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                Dashboard_Client_Report.Advanced_Tax_Report,

                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getDetails?.data);
            if (res?.status === 0) {
                setFinalData(res?.data);
                getSurchargeData();
                getHealthEduData();
                // setClientCode("");
                // setTaxYear("");
            }
            else {
                setFinalData([]);
                setErrorGrid(res?.message);
            }
        } catch (error) {
            console.log(error);
            setServerError(error?.message);

        } finally {
            setLoader(false);
            setCustomShow(false)
            setSelectDuration("")
        }
    };

    const getSurchargeData = async () => {
        
        try {
            const getDetails = await axiosInstance.get(
                Dashboard_Client_Report.SurchargeMaster,

            );
            const res = ApiResDecrypt(getDetails?.data);
            if (res?.status === 0) {
                setSurchargeData(res?.data)
            }
            else {
                setSurchargeData([]);
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);
            // setServerError(error?.message);
        }
    };

    const getHealthEduData = async () => {
        
        try {
            const getDetails = await axiosInstance.get(
                Dashboard_Client_Report.Health_Education_Master,
            );
            const res = ApiResDecrypt(getDetails?.data);
            if (res?.status === 0) {
                setHealthEduData(res?.data)
            }
            else {
                setHealthEduData([]);
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const isExcelDataValid = () => {
        if (!taxReportPayload) return false;
        const { calculations, capitalGainOutsideBB } = taxReportPayload;

        if (!calculations || !capitalGainOutsideBB) return false;

        const allCalculationsFilled = calculations.every(
        item =>
            item.amount !== null &&
            item.amount !== "" &&
            !isNaN(Number(item.amount))
    );

    const allOutsideFilled = capitalGainOutsideBB.every(
        item =>
            item.amount !== null &&
            item.amount !== "" &&
            !isNaN(Number(item.amount))
    );

    console.log("taxReportPayload", taxReportPayload);

        return allCalculationsFilled && allOutsideFilled;
    };

    const handleOnClick = (e) => {
    
        const type = e?.target?.value; 
    setShow(false);
    setTaxYearShow(false);
    setErrorGrid("");

    let isValid = true;

    // ✅ Validate only for table generation
    if (type === "table") {

        if (!clientCode) {
            setSubmitNameError("Please Select Client Name/Code");
            isValid = false;
        } else {
            setSubmitNameError("");
        }

        if (!taxYear) {
            setTaxYearError("Please Select Tax Year");
            isValid = false;
        } else {
            setTaxYearError("");
        }

        if (!isValid) return;

        getAdTaxTableData();
        return;
    }

    // ✅ Excel Validation
    if (type === "excel" || type === "mail") {

        if (Object.keys(finalData).length === 0) {
            toast.error("Please generate the report first.");
            return;
        }

        if (!isExcelDataValid()) {
            toast.error("Report calculation is not ready yet.");
            return;
        }

        getAdTaxExcelData(type);
        return;
    }
    };

     const getAdTaxExcelData = async (type) => {
         if (!taxReportPayload) return;
         if(type === "excel"){
         setSmallLoaderExcel(true)
         }
         if(type === "mail"){
            setSmallLoaderMail(true)
         }
        let payloadValue = {
            clientCode: localStorage.getItem("taxClCode"),
            ...taxReportPayload,
            filetype: type,
        };
        console.log(payloadValue, "payloadValueExcel");

        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                Dashboard_Client_Report.Tax_Report_Excel,

                `"${encPayload}"`,

            );
            const res = ApiResDecrypt(getDetails?.data);
            if (res?.status === 0) {
                if(type === "excel"){
                window.open(res?.data, "_self", "noopener,noreferrer");
                }
                if(type === "mail"){
                    toast.success("Mail sent Successfully")
                }
            }
            else {
                setFinalData([]);
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.message);

        } finally {
            setSmallLoaderExcel(false)
            setSmallLoaderMail(false)
        }
    };


    return (
        <>
            <Header portal={"RM"} />
            {/* <Sidebar /> */}
            <SingleSignOnSideBar />
            <main id="main-content" className="reports">
                <div className="card-box ad-tax-report">
                    {/* <div>
            <h2 className="report-title">Advance Tax Report</h2>
          </div> */}
                    <div className="row input-field-wrapper">
                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group" ref={dropdownRef}>
                                <label className="form-label">Client Search</label>
                                <div className="rm-custom-dropdown">
                                    <input
                                        type="text"
                                        name="search-text"
                                        className="input-st"
                                        placeholder="Search here..."
                                        autoComplete="off"
                                        value={clientCode}
                                        ref={clientInputRef}
                                        onChange={(e) => {
                                            const { selectionStart, selectionEnd, value } = e.target;
                                            let input = value
                                                .toUpperCase()
                                                .replace(/[^A-Z0-9]/g, "")
                                            e.target.value = input;
                                            e.target.setSelectionRange(selectionStart, selectionEnd);
                                            localStorage.setItem("taxClCode", input)
                                            setClientCode(input);
                                            setShow(true);
                                            setErrorGrid(false);
                                            setSubmitNameError(false);
                                            setIsSelected(false);
                                        }}
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            const pasteText = e.clipboardData.getData("text").toUpperCase();
                                            const filtered = pasteText.replace(/[^A-Z0-9]/g, "");
                                            setClientCode(filtered);
                                            setShow(true);
                                            setErrorGrid(false);
                                            setSubmitNameError(false);
                                            setIsSelected(false);
                                        }}
                                    />
                                    <button
                                        className="rm-dropdown-btn"
                                        onClick={() => setShow(!show)}
                                    >
                                        <span className="icon-right-arrow-triangle"></span>
                                    </button>
                                    {show && (
                                        <>
                                            <ul
                                                className="rm-mapping-ap border-0"
                                                onScroll={(e) => handleScroll(e)}
                                            >
                                                {clientList &&
                                                    clientList.map((item, i) => (
                                                        <li
                                                            key={i}
                                                            className="rm-maping-item-wrapper"

                                                            onClick={() => {
                                                                setClientCode(item?.clientCode);
                                                                setShow(false);
                                                                setIsSelected(true);
                                                            }}
                                                        >
                                                            <div> {item?.clientname}</div>
                                                            <div> {item?.clientCode}</div>

                                                        </li>
                                                    ))}
                                                {scrollLoader && !loader && (
                                                    <div className="loader-center">
                                                        <LoaderForSearch />
                                                    </div>
                                                )}
                                                {nameError && !scrollLoader && (
                                                    <li
                                                        className="rm-maping-item-wrapper"
                                                        style={{
                                                            borderBottom: "none",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {nameError}
                                                    </li>
                                                )}
                                            </ul>
                                        </>
                                    )}
                                </div>
                                {submitNameError && (
                                    <span className="to-date-error" style={{ bottom: "-8px" }}>{submitNameError}</span>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group" ref={taxYearDropdownRef}>
                                <label className="form-label">Tax Year – Year Selection</label>
                                <div className="rm-custom-dropdown">
                                    <input
                                        type="text"
                                        name="tax-year"
                                        className="input-st"
                                        placeholder="Search here..."
                                        autoComplete="off"
                                        value={taxYear}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9-]/g, "");
                                            setTaxYear(value);
                                            setTaxYearShow(true);
                                            if (value) {
                                                setTaxYearError("");
                                            }
                                            }}
                                        onClick={() => { 
                                            setTaxYear(taxYear);
                                            setTaxYearShow(true);
                                            setTaxYearError("")
                                        }}
                                    />
                                    <button
                                        className="rm-dropdown-btn"
                                        onClick={() => setTaxYearShow(!taxYearShow)}
                                    >
                                        <span className="icon-right-arrow-triangle"></span>
                                    </button>
                                    {taxYearShow && (
                                        <>
                                        <ul className="rm-mapping-ap border-0">
                                         {taxYearOptions
                                            .filter((year) => year.includes(taxYear))
                                            .map((year, i) => (
                                            <li
                                                key={i}
                                                className="rm-maping-item-wrapper"
                                                onClick={() => {
                                                setTaxYear(year);
                                                setTaxYearShow(false);
                                                }}
                                            >
                                                {year}
                                            </li>
                                            ))}
                                        </ul>
                                        </>
                                    )}
                                </div>
                                {taxYearError && (
                                <span className="to-date-error" style={{ bottom: "-8px" }}>
                                    {taxYearError}
                                </span>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group">
                                <label className="form-label">
                                Taxpayer Category
                                </label>

                                <select
                                    className="report-custom-select"
                                    value="individual"
                                    disabled
                                    style={{fontSize: "12px"}}
                                    // onChange={(e)=> setTaxCategory(e.target.value)}
                                >
                                <option value="individual">Individual</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="text-center search-btn-wrapper">
                        <button
                            value="table"
                            className="send-message"
                            onClick={handleOnClick}
                            disabled={loader || !isSelected}
                        >
                            SUBMIT
                        </button>
                    </div>

                    <div>
                        <ReportTableHeader
                        smallLoaderMail={smallLoaderMail}
                        showEmailBtn={true}
                        smallLoaderExcel={smallLoaderExcel}
                        smallLoaderPdf={smallLoaderPdf}
                        handleOnClick={handleOnClick}
                        showPdfBtn={false}
                        />
                    </div>

                    <div className="for-grid-section pnl-wrapper itr-report">

                        {loader ? (
                            <div className="loader-alignment">
                                <Loader />
                            </div>
                        ) : finalData && Object.keys(finalData).length > 0 ? (
                            <>
                                <div>
                                    <AdvanceTaxReportTable
                                        finalData={finalData}
                                        downloadLoader={downloadLoader} 
                                        surchargeData={surchargeData}
                                        healthEduData={healthEduData} 
                                        setTaxReportPayload={setTaxReportPayload} />
                                </div>
                            </>
                        ) : serverError ? (
                            <h4 className="report-error-message">
                                {noDataFound(serverError)}
                            </h4>
                        ) : (
                            errorGrid && noDataFound(errorGrid)
                        )}
                    </div>
                </div>
            </main >
        </>
    );
}

export default AdvanceTaxReport;
